<template>
<div class="col-12 col-md-12 col-lg-6 col-xl-4 py-2">

   <div class="card-wrapper card-space">
      <div class="card card-bg no-after" 
         :class="[
            {[`bg-${type}`]: type},
            {['card-img']: news.item.image != null},
         ]">
         <!-- Layout of card with image present -->
         <div v-if="news.item.image">
            <div class="category-top" v-if="news.item.schema || news.item.created">
               <a class="category text-uppercase">{{ news.item.schema }}</a>
               <span class="date float-right text-uppercase">{{ news.item.created }}</span>
            </div>            
            <div class="img-responsive-wrapper">
               <div class="img-responsive">
                  <figure class="img-wrapper" >
                     <img :src="news.item.image[0].immagine+'&q=75&w=480'" :alt="news.item.image[0].didascalia">
                  </figure>
               </div>
            </div>            
         </div>

         <div class="card-body" :class="bodyClasses" v-if="!noBody">
            <!-- Layout of card if NO image present -->
            <div class="category-top"  v-if="!news.item.image">
               <a class="category text-uppercase">{{ news.item.schema }}</a>
               <span class="date float-right text-uppercase">{{ news.item.lastModified }}</span>
            </div>            
            <!-- Layout of card if NO image present -->
            <router-link :to="{path: link, params: {slug: news.item.slug, id: news.item.id, area:news.item.area, title: news.item.titolo } }">
               <h5 class="card-title">
                  {{news.item.titolo}}
               </h5>  
            </router-link>

            <p class="card-text">{{news.item.breve}}</p>

            <div class="head-tags mt-auto mb-2" v-if="news.item.argomenti &&  news.item.argomenti.length > 0">
               <h6 class="x-small font-weight-semibold d-none">Tag</h6>
               <div class="align-items-center  mt-4 mt-md-0">
                  <argomento v-for="(argomento, val) in news.item.argomenti" :tag="argomento" :key="val"></argomento>
               </div>
            </div>

         </div>

         <slot v-if="noBody"></slot>


         <div class="it-card-footer" v-if="!noFooter">
            <div class="separator">       
               <router-link :to="{path: link, params: {slug: news.item.slug, id: news.item.id, area:news.item.area, title: news.item.titolo } }">
                  <span class="read-more">Leggi di più</span><svg class="icon">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="img/sprite.svg#it-arrow-right"></use></svg>
               </router-link>                     
               <div class="d-flex ml-auto">
                  <shareArea :hasLabel="false" :url="link" />
               </div>                  
            </div>
         </div>    
      </div>
   </div>
</div>
</template>
<script>
import ShareArea from "@/components/ShareArea";
import argomento from "@/components/Arguments.vue";

export default {
   name: "card",
   components:{
      ShareArea,
      argomento
   },
   props: {
      type: {
        type: String,
        description: "Card type"
      },
      path: {
        type: String,
        default: "",
        description: "Card path"
      },         
      news: {
        type: Object,
        description: "News item object"
      },     
      area: {
        type: String,
        description: "La categoria che l'articolo si partiene"
      },        
      noBody: {
        type: Boolean,
        default: false,
        description: "Whether card should have wrapper body class"
      },
      noFooter: {
        type: Boolean,
        default: false,
        description: "Whether card should have a footer"
      },            
      bodyClasses: {
        type: [String, Object, Array],
        description: "Card body css classes"
      }
   },
   computed:{
      link: function () {
         let schema = this.$props.news.item.schema;
         if(schema == 'evento'){
            return process.env.VUE_APP_URL_EVENTI + this.$props.news.item.slug;
         }
         else if(schema == 'articolo'){           
            if(!(this.$props.news.item.areeSpecializzazione.length > 0) && (!(this.$props.news.item.s3.length > 0) || this.$props.news.item.s3 !== null)){
               return process.env.VUE_APP_URL_NOTIZIE + this.$props.news.item.slug;
            }
            else if(this.$props.news.item.areeSpecializzazione.length > 0 && (this.$props.news.item.s3 == null || !(this.$props.news.item.s3.length > 0))){
               let areaId = this.$props.news.item.areeSpecializzazione[0];
               let area = this.$root.getAreeSpeciali(new Array(areaId));
               return process.env.VUE_APP_URL_AREA + area[areaId].slug + '/' + this.$props.news.item.slug;
            } 
            else if(this.$props.news.item.areeSpecializzazione.length > 0 && (this.$props.news.item.s3 == null || !(this.$props.news.item.s3.length > 0))){
               return process.env.VUE_APP_URL_S3 + this.$props.news.item.slug;
            } 
            else{
               return this.$props.news.item.slug;  
            }
         }
         else if(schema == 'notizia'){
            return process.env.VUE_APP_URL_NOTIZIE + this.$props.news.item.slug;
         }
         else{
            return "/"+this.$props.news.item.slug;  
         }
      }
   }, 
};
</script>
<style scoped>
.read-more {
   color: #003594;
   text-transform: uppercase;
   font-weight: bold;
   letter-spacing: .9px;
   font-size: .77778rem;
}
</style>
